export default __webpack_public_path__ + "static/media/logoLoginWhite.0ffb062b.svg";